import * as React from 'react';

import {
  Box,
  Container
} from '@mui/material';
import {v4 as uuidv4} from "uuid";

import LoadSpinner from '../common/NavBar/LoadSpinner';
import { Outlet } from 'react-router';
import MenuAppBar from '../common/MenuAppBar';

/**
 * @function Layout
 * @description Latout que se renderiza una vez logueado el usuario.
 * @returns {React.JSX.Element}
 */
export default function Layout (): React.JSX.Element {
	return (
    <>
      <Box
        key={uuidv4()}
        sx={{
          width: "100vw",
          height: "100vh",
          display: "flex",
          flexDirection: "column-reverse"
        }}
      >
        <Container
          key={uuidv4()}
          disableGutters
          maxWidth={false}
          sx={{
            flexGrow: 1,
            position: "relative",
            height: "100%",
            width: "100vw",
            overflow:"auto",
            alignSelf: 'flex-end'
          }}
        >
          <Outlet />
        </Container>
        <LoadSpinner key={uuidv4()} />
        <MenuAppBar key={uuidv4()} />
      </Box>
    </>
	)
}
